/**
 * Persistente Tabellen-Spaltenwahl pro Benutzer und Übersicht.
 * Speichert in localStorage unter mamv.columns.<userId>.<viewKey>.
 */
export function storageKeyForColumns(viewKey, userId = 'anon') {
  return `mamv.columns.${userId || 'anon'}.${viewKey}`;
}

export function loadColumnPrefs(viewKey, defaultColumns, userId = 'anon') {
  const defaults = Array.isArray(defaultColumns) ? defaultColumns : [];
  try {
    const raw = localStorage.getItem(storageKeyForColumns(viewKey, userId));
    if (!raw) return defaults.map((c) => ({ ...c }));
    const saved = JSON.parse(raw);
    if (!saved || typeof saved !== 'object') return defaults.map((c) => ({ ...c }));
    return defaults.map((c) => ({
      ...c,
      visible: Object.prototype.hasOwnProperty.call(saved, c.key) ? Boolean(saved[c.key]) : c.visible,
    }));
  } catch {
    return defaults.map((c) => ({ ...c }));
  }
}

export function saveColumnPrefs(viewKey, columns, userId = 'anon') {
  const map = {};
  (columns || []).forEach((c) => {
    map[c.key] = c.visible !== false;
  });
  localStorage.setItem(storageKeyForColumns(viewKey, userId), JSON.stringify(map));
}
